var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box, Switch, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
const VerticalSwitchContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0px',
});
const RotatedSwitch = styled(Switch)(({ $noData }) => (Object.assign({ transform: 'rotate(-90deg)', margin: '0 -6px' }, ($noData && {
    '& .MuiSwitch-switchBase': {
        transform: 'translateX(10px)',
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: '#9e9e9e',
    },
}))));
const SwitchLabel = styled(Typography)(({ theme }) => ({
    fontSize: '12px',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    userSelect: 'none',
    lineHeight: 1,
}));
const LeftLabel = styled(SwitchLabel)({
    marginRight: '-10px',
});
const RightLabel = styled(SwitchLabel)({
    marginLeft: '-10px',
});
export const VerticalSwitch = (_a) => {
    var { checked, disabled, noData, onChange } = _a, props = __rest(_a, ["checked", "disabled", "noData", "onChange"]);
    return (React.createElement(VerticalSwitchContainer, null,
        React.createElement(LeftLabel, null, "\u0414"),
        React.createElement(RotatedSwitch, Object.assign({ checked: noData ? false : checked, disabled: disabled, "$noData": noData, onChange: onChange }, props)),
        React.createElement(RightLabel, null, "\u041A")));
};
